<template>
     <div>
        <help-hub-breadcrumb
            :is-self-service="false"
            :title="pageTitle"
            :key="componentKey"
            class="guided-help-breadcrumb">
        </help-hub-breadcrumb>
        <help-hub-guided-help :title="pageTitle" 
            :key="componentKey" 
            :user-id="loggedUser"
            :current-user-access-token="token" />
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { safeImportComponent } from "@/utils/componentImportUtils";

export default {    
    name: "guided-help-page",
    data(){
        return {
            pageTitle: "Guided Help",
            loggedUser: null,
            token: null,
            componentKey: 0
        }
    },
    watch: {
        "user.userName": function() {            
            this.loggedUser = this.authResponse.user.userName;
            //Re triggers the component
            this.componentKey++;
        }
    },
    computed: {
        ...mapGetters(["authResponse", "user"])
    },
    created() {
        this.loggedUser = this.authResponse.user.userName;
        this.token = this.authResponse.accessToken;

        safeImportComponent(HH_COMPONENTS_URL + "/helphubguidedhelp.umd.min.js");

        this.$nextTick(() => {
            this.componentKey++;
        })
    },
}
</script>
<style>
    .guided-help-breadcrumb section.section-non-self-service {
        height: 300px !important;
    }
.guided-help-wrapper {
    margin-top: -190px !important;
}

@media only screen and (max-width: 767px) { 
    .guided-help-wrapper {
        margin-top: -270px !important;
    }
}
</style>
